import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, MaybeAsync, Resolve, RouterStateSnapshot } from '@angular/router';
import { SubpageAppEntitySubpageRead } from '../openapi';
import { selectSubpages } from '../store/selectors/app.selectors';
import { filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubpageResolver implements Resolve<SubpageAppEntitySubpageRead | null> {

  constructor(private store$: Store) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<SubpageAppEntitySubpageRead | null> {
    return this.store$.select(selectSubpages).pipe(
      filter(v => !!v.length),
      map(v => v.filter(s => s.url === route.params['subpageUrl'])[0] || null)
    );
  }
}
